// EditarPerfil.js
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import BasicLayout from "../../layauots/BasicLayout";
import { Card } from "react-bootstrap";
import MDBox from "../../controls/MDBox";
import MDTypography from "../../controls/MDTypography";
import MDInput from "../../controls/MDInput";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import MDButton from "../../controls/MDButton";
import { Alert, AlertTitle, Checkbox } from "@mui/material";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import { getData, pathData, postData } from "../../Utils/Http/api";

const PerfilEdit = () => {
  const { id } = useParams(); // Obtener el parámetro de la URL (el ID del perfil a editar)
  const [perfil, setPerfil] = useState(null);
  const [idperfil, setidperfil] = useState("");
  const [nombre, setNombre] = useState("");
  const [activo, setActivo] = useState(false);
  const [limiteRegistros, setLimiteRegistros] = useState(100);
  const [puedeReasignarCasos, setPuedeReasignarCasos] = useState(false);
  const [gestionesMinimasDia, setGestionesMinimasDia] = useState(0);
  const [puedeGestionarDisparador, setPuedeGestionarDisparador] = useState(false);
  const [puedeEditarCalendario, setPuedeEditarCalendario] = useState(false);
  const [nombreboton, setnombreboton] = useState("Cancelar");
  const [mensaje, setMensaje] = useState("");
  const history = useNavigate();
  const [grabando, setGrabando] = useState(false);

  const handleVolver = () => {
    history("/Perfil/Perfiles"); // Cambia '/ruta-de-listado' por la ruta real de tu listado de datos
  };

  useEffect(() => {
    setidperfil(id);
    // Aquí realizas la llamada a tu API para obtener el perfil específico por su ID
    const GetPerfil = async () => {
      try {
        const reqperfil = {
          idperfil: id
        };

        const data = await getData(`PerfilGet/${id}`);

       
        setPerfil(data.value);
        setNombre(data.value.nombre);
        setActivo(data.value.activo);
        setLimiteRegistros(data.value.limiteRegistros ?? 100);
        setPuedeReasignarCasos(!!data.value.puedeReasignarCasos);
        setGestionesMinimasDia(data.value.gestionesMinimasDia ?? 0);
        setPuedeGestionarDisparador(!!data.value.puedeGestionarDisparador);
        setPuedeEditarCalendario(!!data.value.puedeEditarCalendario);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    GetPerfil();
  }, [id]);

  const handleSubmit = async (event) => {

    try {
      setGrabando(true); // Inicia la grabación
      setnombreboton("Volver");

      const res = await pathData("PerfilUpdate", {
        idperfil,
        nombre,
        activo,
        limiteRegistros: parseInt(limiteRegistros, 10) || 100,
        puedeReasignarCasos,
        gestionesMinimasDia: Math.max(parseInt(gestionesMinimasDia, 10) || 0, 0),
        puedeGestionarDisparador,
        puedeEditarCalendario,
      });


      // Manejar la lógica después de actualizar el perfil
      if (res.isSuccess) {
        // Manejar respuesta exitosa
        setMensaje("¡Datos actualizados exitosamente!");
        setGrabando(true); 
      } else {
        // Manejar errores si la respuesta no es exitosa
        setMensaje(res.error);
        setGrabando(false); 
        setnombreboton("Cancelar");
      }
    } catch (error) {
      setMensaje("Error en la solicitud:", error);
      setGrabando(false); 
      setnombreboton("Cancelar");
    }
  };

  if (!perfil) {
    return <div>Cargando perfil...</div>;
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="warning"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Editar Perfil
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            un perfil permite asignarle permisos de visualizacion o acciones a un usuario
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="nombre"
                required
                label="Nombre"
                variant="standard"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>

              <Checkbox name="activo"
                onChange={(e) => setActivo(e.target.checked)}
                checked={activo}

              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Activo
              </MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="number"
                name="limiteRegistros"
                label="Límite de registros en Gestión Pre-Judicial y Judicial"
                variant="standard"
                inputProps={{ min: 1 }}
                value={limiteRegistros}
                onChange={(e) => setLimiteRegistros(e.target.value)}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <Checkbox name="puedeReasignarCasos"
                onChange={(e) => setPuedeReasignarCasos(e.target.checked)}
                checked={puedeReasignarCasos}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Puede reasignar casos de otros gestores
              </MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="number"
                name="gestionesMinimasDia"
                label="Gestiones mínimas por día (0 = sin mínimo)"
                variant="standard"
                inputProps={{ min: 0 }}
                value={gestionesMinimasDia}
                onChange={(e) => setGestionesMinimasDia(e.target.value)}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <Checkbox name="puedeGestionarDisparador"
                onChange={(e) => setPuedeGestionarDisparador(e.target.checked)}
                checked={puedeGestionarDisparador}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Puede definir la modalidad de gestión de los usuarios
              </MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <Checkbox name="puedeEditarCalendario"
                onChange={(e) => setPuedeEditarCalendario(e.target.checked)}
                checked={puedeEditarCalendario}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Puede editar el Calendario de Gestores
              </MDTypography>
            </MDBox>

            <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
              <MDButton
                onClick={() => {
                  handleSubmit();
                }}
                variant="gradient"
                color="warning"
                endIcon={<Save />}
                disabled={grabando}
                fullWidth
              >
                Grabar
              </MDButton>

              <MDButton
                onClick={() => {
                  handleVolver();
                }}
                variant="gradient"
                color="warning"
                endIcon={<ExitToApp />}

                fullWidth
              >
                {nombreboton}
              </MDButton>
            </MDBox>
          </MDBox>


          {mensaje !== '' && (
            <Alert severity={"success"}>
              <AlertTitle>{"Aviso"}</AlertTitle>
              {mensaje}
            </Alert>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default PerfilEdit;
